import { render } from "./program-status.vue?vue&type=template&id=71dd2806&ts=true"
import script from "./program-status.vue?vue&type=script&lang=ts"
export * from "./program-status.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__